import React from "react";
import PrescriptionPreview from "./PrescriptionPreview";
import { motion } from "framer-motion";

const PrescriptionHistory = ({ prescriptions, onDateChange, onBackClick, selectedDate }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="max-w-7xl mx-auto px-4 py-8"
    >
      {/* Header Controls */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center mb-10">
        {/* Date Picker */}
        <div className="flex justify-start">
          <input
            type="date"
            value={selectedDate}
            onChange={onDateChange}
            className="w-full md:w-auto border border-purple-300 px-4 py-2 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-400 bg-white text-gray-700"
          />
        </div>

        {/* Title */}
        <div className="flex justify-center text-center">
          <h1 className="text-2xl md:text-3xl font-bold text-purple-700">
            👶 Child's Prescription History
          </h1>
        </div>

        {/* Back Button */}
        <div className="flex justify-end">
          <button
            onClick={onBackClick}
            className="w-full md:w-auto bg-gradient-to-r from-purple-500 to-indigo-600 hover:from-purple-600 hover:to-indigo-700 text-white py-2 px-5 rounded-xl shadow-md hover:shadow-lg transition-transform transform hover:scale-105"
          >
            ⬅️ Back to Dashboard
          </button>
        </div>
      </div>

      {/* Prescription Content */}
      {prescriptions.length === 0 ? (
        <div className="text-center text-gray-500 text-lg py-8">
          No prescriptions found for the selected date.
        </div>
      ) : (
        prescriptions.map((prescription, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: index * 0.1, duration: 0.4 }}
            className="mb-10 bg-white border border-purple-100 rounded-3xl shadow-lg p-6 sm:p-8 hover:shadow-xl transition-all duration-300"
          >
            <div className="mb-3 text-lg font-semibold text-purple-600">
              📅 Date: {prescription.date}
            </div>
            <PrescriptionPreview
              patientName={prescription.patientName}
              date={prescription.date}
              symptoms={prescription.symptoms}
              diagnosis={prescription.diagnosis}
              medicines={prescription.medicines}
              labTests={prescription.labTests}
              sos={prescription.sos}
              notes={prescription.notes}
              nextAppointment={prescription.nextAppointment}
            />
          </motion.div>
        ))
      )}
    </motion.div>
  );
};

export default PrescriptionHistory;
